<soph-header-sophia />

<div class="header-container">
  <h1>Mis Pacientes</h1>
  <div class="back-link">
    <mat-icon>arrow_back</mat-icon>
    <a href="/calendario">Volver a Tu Agenda</a>
  </div>
</div>

<div class="content-container">
  <soph-search-bar
    [filteredList]="listToEmit()"
    idKey="idPaciente"
    labelKey="nombreCompleto"
    (onSearchChange)="updatedSearch($event)"
    (onSelectedOption)="patientClicked( $event )"
  />
  <soph-tabla-pacientes [patientsOriginalList]="patients()" (onSelect)="patientClicked( $event )"/>
  <soph-pager
    [currentPage]="currentPage()"
    [totalElements]="total()"
    [pageSize]="pageSize()"
    (onUpdatePage)="onUpdatePage($event)"
  />
</div>
